export const breakpoints = {
  tablet: 1366,
  mobile: 768,
  portrait: 1024,
} as const;

export const media = {
  tablet: `@media (max-width: ${breakpoints.tablet}px)`,
  mobile: `@media (max-width: ${breakpoints.mobile}px)`,
  portrait: `@media (orientation: portrait) and (max-width: ${breakpoints.portrait}px)`,
  // Narrow portrait (phones): too tight for content + button side-by-side, so
  // the button stacks full-width below the content row.
  portraitMobile: `@media (orientation: portrait) and (max-width: ${breakpoints.mobile}px)`,
} as const;
